export default __webpack_public_path__ + "static/mLogo-9b473515ab71705800640d55f05cd3c2.png";